import { DocumentModel, DocumentMetadata, PageSettings } from '../ast/document.types';

export function updateMetadata(
  doc: DocumentModel,
  updates: Partial<DocumentMetadata>
): DocumentModel {
  return {
    ...doc,
    metadata: {
      ...doc.metadata,
      ...updates,
      modifiedAt: new Date().toISOString(),
    },
  };
}

export function updatePageSettings(
  doc: DocumentModel,
  updates: Partial<PageSettings>
): DocumentModel {
  return {
    ...doc,
    metadata: {
      ...doc.metadata,
      modifiedAt: new Date().toISOString(),
    },
    pageSettings: {
      ...doc.pageSettings,
      ...updates,
    },
  };
}
